export default __webpack_public_path__ + "static/media/mode-icon.651cf792.svg";